<template>
    <header>
        <div :class="['header-container', isFilter ? '--remove-box-shadow' : '']">
            <h1>{{ $t("ProductionProgress.History") }}</h1>
            <button @click="close">
                <CloseIcon v-if="windowWidth > 425 && windowWidth < 768" />
                <CloseIconSmall v-else />
            </button>
        </div>
        <div
            v-if="isFilter"
            class="header__tabs"
        >
            <div
                :class="['tab', currentTab === 'stops' ? 'active' : '']"
                @click="currentTab = 'stops'"
            >
                {{ $t("Stops") }}
            </div>
            <div
                :class="['tab', currentTab === 'quantity' ? 'active' : '']"
                @click="currentTab = 'quantity'"
            >
                {{ $t("OperationProgress.Quantity") }}
            </div>
            <div
                :class="['tab', currentTab === 'parameters' ? 'active' : '']"
                @click="currentTab = 'parameters'"
            >
                {{ $t("Operator.Parameters") }}
            </div>
        </div>
    </header>
</template>

<script>
    import CloseIcon from "@/assets/images/icons/close-icon-1.svg";
    import CloseIconSmall from "@/assets/images/icons/close-icon.svg";

    export default {
        components: {
            CloseIcon,
            CloseIconSmall
        },
        props: {
            isFilter: {
                type: Boolean,
                default: false
            },
            close: {
                type: Function,
                default: () => {}
            }
        },
        data: () => ({
            windowWidth: window.innerWidth,
            currentTab: "stops"
        }),
        watch: {
            currentTab(v) {
                this.$emit("updateTab", v);
            }
        }
    };
</script>

<style lang="scss" scoped>
    .header-container {
        display: flex;
        align-items: center;
        padding: 16px 29px;
        box-shadow:
            0px 3px 4px rgba(0, 0, 0, 0.14),
            0px 3px 3px rgba(0, 0, 0, 0.12),
            0px 1px 8px rgba(0, 0, 0, 0.2);
        user-select: none;
        z-index: 99999999999;

        h1 {
            flex-grow: 1;
            font-weight: 600;
            font-size: 22px;
            line-height: 30px;
            color: #4c4541;
            margin: 0;
        }

        button {
            padding: 0;
            border: none;
            background: none;
        }

        &.--remove-box-shadow {
            border-bottom: 1px solid #cfc4be;
            box-shadow: none;
        }
    }

    .header__tabs {
        display: flex;
        justify-content: center;

        .tab {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            color: #998f8a;
            font-size: 18px;
            font-weight: 600;
            line-height: 26px;
            text-align: center;
            cursor: pointer;
            width: 100%;
            border-bottom: 1px solid #cfc4be;
            padding: 15.5px 16px;

            .filters-quantity {
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
                color: #fff;
                width: 18px;
                height: 18px;
                gap: 10px;
                border-radius: 20px;
                background: #998f8a;
                font-size: 10px;
                font-weight: 600;
                line-height: 14px;
            }

            &.active {
                color: #974900;
                border-color: #a35205;
                box-shadow: 0px -4px 0px 0px #974900 inset;

                .filters-quantity {
                    background: #974900;
                }
            }
        }
    }

    @media (max-width: 768px) and (min-width: 480px) {
        .header-container {
            h1 {
                font-size: 36px !important;
                line-height: 50px !important;
            }
        }
    }

    @media (max-width: 480px) {
        .header-container {
            padding: 16px !important;

            h1 {
                font-size: 18px;
                line-height: 26px; /* 144.444% */
            }
        }
        .header__tabs {
            .tab {
                font-size: 16px;
                line-height: 26px; /* 162.5% */
            }
        }
    }
</style>
